import type { CampaignCreateMutationVariables } from '~/api/graphql/mutations/campaignCreate.generated';
import type { Campaign } from '~/modules/campaign/types';

import { useCampaignCreateMutation } from '~/api/graphql/mutations/campaignCreate.generated';
import { useToast } from '~/hooks/useToast';
import { CAMPAIGN_MSG } from '../constants';

export interface ICreateCampaign<T extends Campaign> {
  isLoadingCreate: boolean;
  onCreateCampaign: (campaign: CampaignCreateMutationVariables) => Promise<T | undefined>;
}

export const useCreateCampaign = <T extends Campaign>(): ICreateCampaign<T> => {
  const { shopifyToast } = useToast();
  const createCampaignMutation = useCampaignCreateMutation();

  const onCreateCampaign = async (
    campaign: CampaignCreateMutationVariables,
  ): Promise<T | undefined> => {
    if (!campaign) return;

    try {
      const { campaignCreate } = await createCampaignMutation.mutateAsync(campaign);
      if (!campaignCreate) {
        throw new Error(CAMPAIGN_MSG.CREATE.FAILED);
      }

      // const newCampaigns = [campaignCreate, ...(campaigns || [])];
      // const sortedCampaigns = Array.from(newCampaigns).sort(compareCampaigns);

      return campaignCreate as T;
    } catch (error) {
      shopifyToast(CAMPAIGN_MSG.CREATE.FAILED, { isError: true });
      return undefined;
    }
  };

  return {
    isLoadingCreate: createCampaignMutation.isLoading,
    onCreateCampaign,
  };
};
